import { ViewStyle } from 'react-native';

export const ARROW_CONTAINER_BASE_STYLE: ViewStyle = {
  position: 'absolute',
  top: '50%',
  transform: [{ translateY: -20 }],
  zIndex: 10,
  opacity: 0.7,
  padding: 5,
};

export const CONTAINER_STYLE: ViewStyle = {
  position: 'relative',
};

export const LEFT_ARROW_CONTAINER_STYLE: ViewStyle = {
  ...ARROW_CONTAINER_BASE_STYLE,
  left: 0,
};

export const RIGHT_ARROW_CONTAINER_STYLE: ViewStyle = {
  ...ARROW_CONTAINER_BASE_STYLE,
  right: 0,
};
